export default __webpack_public_path__ + "static/media/WAG Symbols Bold.0c56a66d.otf";